import { useEffect, useRef } from "react";
import apiClient, { SESSION_EXPIRED_EVENT } from "../api/client";

const PING_INTERVAL_MS = 30_000;
const MAX_FAILURES = 5;

export const useKeepAlive = () => {
  const failureCount = useRef(0);

  useEffect(() => {
    const ping = async () => {
      try {
        await apiClient.get("/health", { timeout: 10_000 });
        failureCount.current = 0;
      } catch {
        failureCount.current += 1;
        if (failureCount.current >= MAX_FAILURES) {
          window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT));
        }
      }
    };

    const id = setInterval(ping, PING_INTERVAL_MS);
    return () => clearInterval(id);
  }, []);
};
